import { Directive, ElementRef, Input, OnChanges } from '@angular/core';
import { SvgSanitizer } from '@ddt-web/pdf-utils';

@Directive({
	selector: '[acSafeSvgContent]'
})
export class SafeSvgContentDirective implements OnChanges {
	@Input() public acSafeSvgContent: string;

	constructor(private elementRef: ElementRef<HTMLElement>) { }

	public ngOnChanges(): void {
		const host = this.elementRef.nativeElement;
		while (host.firstChild) {
			host.removeChild(host.firstChild);
		}
		host.appendChild(SvgSanitizer.sanitizeToFragment(this.acSafeSvgContent, host.ownerDocument));
	}
}
